/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const PeriodProps = PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
});

export const PeriodDefaults = {
    name: '',
    description: '',
    start_date: '',
    end_date: '',
};

export const PeriodsProps = PropTypes.arrayOf(PeriodProps);

export const PeriodsDefaults = [];
